import React from "react"

/**
 * Renders an SVG icon component, handling both direct components and module objects.
 * This is needed for Next.js 16 compatibility where SVG imports may return objects
 * instead of direct React components.
 *
 * @param Icon - The imported SVG icon (may be a component or module object)
 * @param className - CSS classes to apply to the icon
 * @param props - Additional props to pass to the icon component
 */
export function renderIcon(Icon: any, className?: string, props?: Record<string, any>) {
    if (!Icon) return null

    // Handle case where Icon might be a module with default export
    const IconComponent = Icon?.default || Icon

    // Check if it's a valid React component
    if (typeof IconComponent === "function" || (typeof IconComponent === "object" && IconComponent !== null && "$$typeof" in IconComponent)) {
        return <IconComponent className={className} {...props} />
    }

    return null
}

/**
 * Higher-order component that wraps an SVG import to ensure it works as a component.
 * Use this when you need to pass an icon as a prop or store it in state.
 *
 * @param Icon - The imported SVG icon
 */
export function wrapIcon(Icon: any): React.ComponentType<{ className?: string }> {
    const IconComponent = Icon?.default || Icon

    if (typeof IconComponent === "function" || (typeof IconComponent === "object" && IconComponent !== null && "$$typeof" in IconComponent)) {
        return IconComponent
    }

    // Return a no-op component if the icon is invalid
    return () => null
}
